/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { defaultLoadableState, LoadableState } from '@opengamma/ui';
import { TenantAttribute, TenantDetails, User } from 'app/page-modules/tenant-management/models';

/** Tenants state. */
export interface TenantManagementState {
  selectedTenant: LoadableState<TenantDetails>;
  usersForSelectedTenant: LoadableState<User[]>;
  selectedTenantEditable: boolean;
  selectedTenantBiEditable: boolean;
  tenantAttributeBeingUpdated: TenantAttribute;
  newUser: LoadableState<User>;
  userCreationWizardShown: boolean;
  tenantCreationInProgress: boolean;
  tenantCreationWizardShown: boolean;
}

/** The initial app state. */
export const INITIAL_STATE: TenantManagementState = {
  selectedTenant: defaultLoadableState(),
  tenantAttributeBeingUpdated: 'none',
  usersForSelectedTenant: defaultLoadableState(),
  selectedTenantEditable: false,
  selectedTenantBiEditable: false,
  newUser: defaultLoadableState(),
  userCreationWizardShown: false,
  tenantCreationInProgress: false,
  tenantCreationWizardShown: false
};
